import { Route, Switch, useRouteMatch } from "react-router-dom";

import { IndependentContractorBadgePage } from "./components/IndependentContractorBadge/Page";
import { DocumentDetailsPageContainer } from "./Details/Container";
import { DocumentsPageContainer } from "./DocumentsPage/Container";
import { DocumentsPageAccordionProvider } from "./DocumentsPage/useAccordionProvider";
import {
  DOCUMENT_DETAILS_PATH,
  INDEPENDENT_CONTRACTOR_BADGE_PATH,
  WORKPLACE_DOCUMENTS_PATH,
} from "./paths";
import { FileUploaderProvider } from "./useFileUploaderContext";
import { WorkplaceDocumentsPage } from "./Workplace/Page";

export function DocumentsRouter() {
  const match = useRouteMatch();

  return (
    <DocumentsPageAccordionProvider>
      <Switch>
        <Route exact path={`${match.url}`}>
          <DocumentsPageContainer />
        </Route>
        <Route exact path={`${match.url}/${INDEPENDENT_CONTRACTOR_BADGE_PATH}`}>
          <IndependentContractorBadgePage />
        </Route>
        <Route path={`${match.url}/${WORKPLACE_DOCUMENTS_PATH}`}>
          <WorkplaceDocumentsPage />
        </Route>
        <Route path={`${match.url}/${DOCUMENT_DETAILS_PATH}`}>
          <FileUploaderProvider maxFilesCount={5}>
            <DocumentDetailsPageContainer />
          </FileUploaderProvider>
        </Route>
      </Switch>
    </DocumentsPageAccordionProvider>
  );
}
